import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';

const sidebarItems = ['Modifier le profil', 'Gestion de votre compte'];
const sectionLabels = {
  latest_videos: "Dernières vidéos générées",
  trending: "Vidréos en tendance",
  creators: "Créateurs en vedette",
  activity: "Activité récente",
  challenges: "Défis de la communauté",
  suggestions: "Tu pourrais aimer..."
};

const labelToKey = Object.fromEntries(
  Object.entries(sectionLabels).map(([k, v]) => [v, k])
);

export default function SettingsPage() {
  const [account, setAccount] = useState({
    birthdate: '',
    gender: 'Homme',
    country: 'France',
    language: 'fr',
    is_pro: 0
  });

  const { keycloak, token } = useAuth();
  const avatarInputRef = useRef();
  const coverInputRef = useRef();
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('');
  const [active, setActive] = useState('Modifier le profil');
  const sidebarItems = ['Modifier le profil', 'Gestion de votre compte'];
 const sectionOptions = [
  'Dernières vidéos générées',
  'Vidéos en tendance',
  'Créateurs en vedette',
  'Activité récente',
  'Défis de la communauté',
  'Tu pourrais aimer...'
];

const interestOptions = [
  'Voyage', 'Culture', 'Nature', 'Histoire', 'Cuisine',
  'Technologie', 'Écologie', 'Aventure'
];

const WEAVEVO_LANG_KEY = "weavevo_lang";
const getInitialLang = () => {
  try {
    const raw =
      localStorage.getItem(WEAVEVO_LANG_KEY) ||
      localStorage.getItem("weavevo_language") ||
      "";
    const norm = String(raw || "").toLowerCase().slice(0, 2);
    return norm === "fr" ? "fr" : "en"; // default EN
  } catch {
    return "en";
  }
};

const [settings, setSettings] = useState({
  emailNotif: true,
  pushNotif: true,
  darkMode: true,
  language: getInitialLang(), // ✅ default EN
  timezone: 'America/New_York',
  dashboardSections: [...sectionOptions],
  interests: [...interestOptions]
});





  const tooltipRef = useRef(null);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
        setVariant('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  useEffect(() => {
    if (!token) return;
    fetch("/settings", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        let sections = data.dashboard_sections || [];
        if (Array.isArray(sections) && typeof sections[0] === 'string' && sections[0].includes('vid')) {
          // assume valid keys
        } else if (Array.isArray(sections)) {
          sections = sections.map(label => labelToKey[label] || label);
        }

        const apiLang = String(data.language || "").toLowerCase().slice(0, 2);
const nextLang = apiLang === "fr" ? "fr" : "en"; // default EN if empty/unknown

try {
  localStorage.setItem(WEAVEVO_LANG_KEY, nextLang);
  document.documentElement.lang = nextLang;
} catch {}

setSettings(prev => ({
  ...prev,
  emailNotif: data.email_notifications === 1,
  pushNotif: data.push_notifications === 1,
  darkMode: data.dark_mode === 1,
  language: nextLang,
  timezone: data.timezone || 'Europe/Paris',
  dashboardSections: sections,
  interests: data.interests || []
}));

      });
  }, [token]);


  useEffect(() => {
    if (!token) return;
    fetch("/settingAccount", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        setAccount({
          birthdate: data.birthdate || '',
          gender: data.gender || 'Homme',
          country: data.country || 'France',
          language: data.language || 'fr',
          is_pro: data.is_pro || 0
        });
      })
      .catch(console.error);
  }, [token]);

  const handleAccountSave = () => {
    if (!token) return;
    fetch("/settingAccount", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(account)
    })
      .then(res => {
        if (res.ok) {
          setMessage("Compte mis à jour !");
          setVariant("success");
        } else {
          setMessage("Erreur lors de la mise à jour.");
          setVariant("danger");
        }
      })
      .catch(err => {
        console.error(err);
        setMessage("⚠️ Erreur réseau.");
        setVariant("danger");
      });
  };

  const handleSave = () => {
    if (!token) return;
    const payload = {
      email_notifications: settings.emailNotif ? 1 : 0,
      push_notifications: settings.pushNotif ? 1 : 0,
      dark_mode: settings.darkMode ? 1 : 0,
      language: settings.language,
      timezone: settings.timezone,
      dashboard_sections: settings.dashboardSections,
      interests: settings.interests
    };
    fetch("/settings", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (res.ok) {
          setMessage("Paramètres enregistrés avec succès ");
          setVariant("success");
        } else {
          setMessage("Une erreur est survenue lors de l'enregistrement.");
          setVariant("danger");
        }
      })
      .catch(err => {
        console.error("Erreur:", err);
        setMessage("⚠️ Erreur réseau.");
        setVariant("danger");
      });
  };

  return (
    <div className="container py-5">
      {message && (
        <div
          ref={tooltipRef}
          className={`alert alert-${variant}`}
          style={{
            position: 'fixed',
            top: '80px',
            right: '20px',
            zIndex: 9999,
            maxWidth: '300px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            borderRadius: '8px',
            padding: '12px'
          }}
        >
          {message}
        </div>
      )}

      <div className="d-flex justify-content-center mb-4 gap-3 border-bottom pb-2" style={{ paddingTop: '70px' }}>
        {sidebarItems.map((item, index) => (
          <button
            key={index}
            className={`btn ${active === item ? 'btn-dark' : 'btn-outline-secondary'} rounded-pill px-4`}
            onClick={() => setActive(item)}
          >
            {item}
          </button>
        ))}
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-8">
          {active === 'Modifier le profil' && (
            <>
              <h2 className="mb-4">Paramètres</h2>
              <div className="form-check mb-3">
                <input className="form-check-input" type="checkbox" checked={settings.emailNotif}
                  onChange={() => setSettings(prev => ({ ...prev, emailNotif: !prev.emailNotif }))} id="emailNotif" />
                <label className="form-check-label" htmlFor="emailNotif">Notifications par email</label>
              </div>
              <div className="form-check mb-3">
                <input className="form-check-input" type="checkbox" checked={settings.pushNotif}
                  onChange={() => setSettings(prev => ({ ...prev, pushNotif: !prev.pushNotif }))} id="pushNotif" />
                <label className="form-check-label" htmlFor="pushNotif">Notifications push</label>
              </div>
              <div className="form-check mb-3">
                <input className="form-check-input" type="checkbox" checked={settings.darkMode}
                  onChange={() => setSettings(prev => ({ ...prev, darkMode: !prev.darkMode }))} id="darkMode" />
                <label className="form-check-label" htmlFor="darkMode">Mode sombre</label>
              </div>
              <div className="mb-3">
                <label className="form-label">Langue</label>
                <select
  className="form-select"
  value={settings.language}
  onChange={(e) => {
    const next = e.target.value === "fr" ? "fr" : "en"; // ✅ limit to EN/FR for now
    setSettings(prev => ({ ...prev, language: next }));

    try {
      localStorage.setItem(WEAVEVO_LANG_KEY, next);
      document.documentElement.lang = next;
    } catch {}
  }}
>
  <option value="en">English</option>
  <option value="fr">Français</option>
</select>

              </div>
              <div className="mb-4">
                <label className="form-label">Fuseau horaire</label>
                <select className="form-select" value={settings.timezone}
                  onChange={e => setSettings(prev => ({ ...prev, timezone: e.target.value }))}>
                  <option value="Europe/Paris">Europe/Paris</option>
                  <option value="America/New_York">Amérique/New York</option>
                  <option value="Asia/Tokyo">Asie/Tokyo</option>
                </select>
              </div>
              <button className="btn btn-primary" onClick={handleSave}>Sauvegarder</button>
            </>
          )}

          {active === 'Gestion de votre compte' && (
            <>
              <h2 className="mb-4">Votre compte</h2>
              <div className="mb-3">
                <label className="form-label">Adresse e-mail</label>
                <input type="email" className="form-control" value="akremanaya@gmail.com" disabled />
              </div>
              <div className="mb-3">
                <label className="form-label">Mot de passe</label>
                <div className="d-flex align-items-center">
                  <input type="password" className="form-control me-2" value="********" disabled />
                  <button className="btn btn-secondary">Modifier</button>
                </div>
              </div>
              <div className="form-check mb-3">
                <input className="form-check-input" type="checkbox" id="proCheck" checked={account.is_pro === 1}
                  onChange={() => setAccount(prev => ({ ...prev, is_pro: prev.is_pro === 1 ? 0 : 1 }))} />
                <label className="form-check-label" htmlFor="proCheck">Compte professionnel</label>
              </div>
              <div className="mb-5">
                <label className="form-label">Passez à un compte professionnel</label>
                <p className="text-muted">Avec un compte professionnel, vous aurez accès à des outils tels que les annonces et les statistiques.</p>
                <button className="btn btn-outline-dark">Convertir le compte</button>
              </div>
              <h5 className="mb-3">Informations personnelles</h5>
              <div className="mb-3">
                <label className="form-label">Date de naissance</label>
                <input type="date" className="form-control" value={account.birthdate}
                  onChange={e => setAccount(prev => ({ ...prev, birthdate: e.target.value }))} />
              </div>
              <div className="mb-3">
                <label className="form-label">Identité de genre</label>
                <div>
                  {["Homme", "Femme"].map(option => (
                    <div className="form-check form-check-inline" key={option}>
                      <input className="form-check-input" type="radio" name="gender" id={`gender-${option}`} value={option}
                        checked={account.gender === option}
                        onChange={e => setAccount(prev => ({ ...prev, gender: e.target.value }))} />
                      <label className="form-check-label" htmlFor={`gender-${option}`}>{option}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Pays/Région</label>
                <select className="form-select" value={account.country}
                  onChange={e => setAccount(prev => ({ ...prev, country: e.target.value }))}>
                  <option value="France">France</option>
                  <option value="Tunisie">Tunisie</option>
                  <option value="Canada">Canada</option>
                  <option value="États-Unis">États-Unis</option>
                  <option value="Allemagne">Allemagne</option>
                </select>
              </div>
              <button className="btn btn-primary mt-3" onClick={handleAccountSave}>Sauvegarder les infos du compte</button>

            </>
          )}




        </div>
      </div>
    </div>
  );
}
